import {Component, EventEmitter, Input, Output} from '@angular/core';
import {DashboardNotification, DashboardNotificationAction} from '@core/types';

@Component({
  selector: 'core-notification-tray',
  imports: [],
  templateUrl: './notification-tray.html',
  styleUrl: './notification-tray.scss',
  standalone: true,
  host: {
    style: 'display:flex;height: 100%;width: 100%;overflow-x:hidden;overflow-y:auto'
  }
})
export class NotificationTray {
  @Output() close = new EventEmitter<DashboardNotification>();
  @Output() action = new EventEmitter<{notification: DashboardNotification; action: DashboardNotificationAction}>();

  notifications: DashboardNotification[] = [];
  private loadingSet = new Set<string | number>();
  private expandedSet = new Set<string | number>();

  @Input()
  set items(value: DashboardNotification[] | null | undefined) {
    if (value) {
      this.notifications = value;
    }
  }

  @Input()
  set loadingIds(value: Set<string | number> | Array<string | number> | null | undefined) {
    if (!value) {
      this.loadingSet = new Set();
      return;
    }
    this.loadingSet = value instanceof Set ? value : new Set(value);
  }

  @Input()
  expandable = true;

  @Input()
  showClose = true;

  @Input()
  showActions = true;

  @Input()
  expandedByDefault = true;

  handleClose(notification: DashboardNotification) {
    this.close.emit(notification);
  }

  handleAction(notification: DashboardNotification, action: DashboardNotificationAction) {
    this.action.emit({notification, action});
  }

  isLoading(notification: DashboardNotification): boolean {
    return !!notification?.id && this.loadingSet.has(notification.id);
  }

  toggleExpanded(notification: DashboardNotification) {
    if (!this.expandable) return;
    if (!notification?.id) return;
    if (this.expandedSet.has(notification.id)) {
      this.expandedSet.delete(notification.id);
    } else {
      this.expandedSet.add(notification.id);
    }
  }

  isExpanded(notification: DashboardNotification): boolean {
    if (!this.expandable) return this.expandedByDefault;
    return !!notification?.id && this.expandedSet.has(notification.id);
  }
}
